function TenantUnmanagedDevicesCtrl($scope, $log, $stateParams, TenantsService, DevicesService, ProgressBarService, ToastsService, SessionsService, $mdDialog, $state) {
  "ngInject";

  let vm = this;
  vm.currentTenant = {
    key: undefined,
    name: undefined,
    code: undefined,
    adminEmail: undefined,
    contentServerUrl: undefined,
    contentManagerBaseUrl: undefined,
    domainId: undefined,
    notificationEmails: undefined,
    proofOfPlayLogging: false,
    active: true
  };
  vm.gcmidDevices = [];
  vm.tenantDevices = [];
  vm.devicesPrev = null;
  vm.devicesNext = null;
  vm.selectedButton = "Serial Number";
  vm.serialDevices = {};
  vm.idDevices = {};
  vm.disabled = true;
  vm.macDevices = {};
  vm.devicesToMatchOn = [];
  vm.editMode = !!$stateParams.tenantId;
  vm.tenantId = $stateParams.tenantId;
  vm.admin = SessionsService.getIsAdmin();

  vm.editItem = (item) => DevicesService.editItem(item)

  vm.getUnmanagedDevices = function (tenantId, page) {
    ProgressBarService.start();
    let devicesPromise = DevicesService.getUnmanagedDevicesByTenant(tenantId, page);
    return devicesPromise.then(function (data) {
      vm.devicesPrev = data["previous"];
      vm.devicesNext = data["next"];
      vm.tenantDevices = data["devices"];
      vm.devicesCount = data["count"];
      return ProgressBarService.complete();
    });
  };

  if (vm.editMode) {
    let tenantPromise = TenantsService.getTenantById(vm.tenantId);
    tenantPromise.then(tenant => vm.currentTenant = tenant);
    vm.getUnmanagedDevices(vm.tenantId, null, null);
  }

  vm.refreshDevices = function () {
    vm.devicesPrev = null;
    vm.devicesNext = null;
    vm.tenantDevices = null;
    return vm.getUnmanagedDevices(vm.tenantId, vm.devicesPrev, vm.devicesNext);
  };

  vm.changeRadio = function () {
    vm.searchText = '';
    vm.disabled = true;
    vm.serialDevices = {};
    vm.idDevices = {};
    vm.macDevices = {};
    vm.devicesToMatchOn = [];
  };

  vm.searchDevices = function (partial) {
    let unmanaged = true;
    let byTenant = true;
    return DevicesService.searchDevices(partial, vm.selectedButton, byTenant, vm.tenantId, vm.managingOrgId, unmanaged)
      .then(function (response) {
        let devicesToReturn;
        if (response.success) {
          let devices = response.devices;
          if (vm.selectedButton === "Serial Number") {
            vm.serialDevices = devices[1];
            devicesToReturn = devices[0];
          } else if (vm.selectedButton === "Device Key") {
            vm.idDevices = devices[1];
            devicesToReturn = devices[0];
          } else if (vm.selectedButton === "MAC") {
            vm.macDevices = devices[1];
            devicesToReturn = devices[0];
          } else {
            vm.gcmidDevices = devices[1];
            devicesToReturn = devices[0];
          }
          vm.devicesToMatchOn = devicesToReturn;
          return devicesToReturn;
        } else {
          return [];
        }
      });

  };

  vm.confirmUnmanagedDeviceCreate = () => {
    let confirm = $mdDialog.confirm(
      {
        title: 'Are you sure you want to create a new Android/Preview Device?',
        textContent: 'Please remember, you MUST pair this device after this creation step.',
        targetEvent: event,
        ok: 'Create Android/Preview Device',
        cancel: 'Cancel'
      }
    );
    let showPromise = $mdDialog.show(confirm);
    let success = () => vm.onConfirmCreateUnmanaged();
    let failure = () => vm.onConfirmCancel();
    return showPromise.then(success, failure);
  };

  vm.onConfirmCreateUnmanaged = function () {
    let success = function (newDevice) {
      ToastsService.showSuccessToast('We processed your Android/Preview Device creation request.');
      return $state.go('main.editDevice', {tenantId: $stateParams.tenantId, deviceId: newDevice.key});
    };
    let failure = function (error) {
      let friendlyMessage = 'We were unable to complete your Android/Preview Device creation request at this time.';
      ToastsService.showErrorToast(friendlyMessage);
      return $log.error(`Create Android/Preview Device failure on tenant ${vm.currentTenant.id}: ${error.status } ${error.statusText}`);
    };
    let createPromise = TenantsService.createUnmanagedDevice(vm.currentTenant.id);
    return createPromise.then(success, failure);
  };

  vm.onConfirmCancel = () => ToastsService.showInfoToast('We canceled your Android/Preview Device creation request.');

  vm.prepareForEditView = (searchText) => DevicesService.prepareForEditView(
    vm.selectedButton,
    vm.tenantId,
    searchText,
    vm.macDevices,
    vm.serialDevices,
    vm.idDevices,
    vm.gcmidDevices
  );

  vm.controlOpenButton = function (isMatch) {
    vm.disabled = !isMatch;
    vm.loadingDisabled = false;
  };

  vm.isResourceValid = function (resource) {
    let foundMatch = false;
    for (let item of vm.devicesToMatchOn) {
      if (resource === item) {
        foundMatch = true;
      }
    }
    vm.controlOpenButton(foundMatch)
    return foundMatch
  };

  $scope.tabIndex = 2;

  $scope.$watch('tabIndex', function (toTab, fromTab) {
    if (toTab !== undefined) {
      switch (toTab) {
        case 0:
          return $state.go('main.tenantDetails', {tenantId: $stateParams.tenantId});
        case 1:
          return $state.go('main.tenantManagedDevices', {tenantId: $stateParams.tenantId});
        case 2:
          return $state.go('main.tenantUnmanagedDevices', {tenantId: $stateParams.tenantId});
        case 3:
          return $state.go('main.tenantLocations', {tenantId: $stateParams.tenantId});
        case 4:
          return $state.go('main.tenantOverlays', {tenantId: $stateParams.tenantId});
        case 5:
          return $state.go('main.tenantLogs', {tenantId: $stateParams.tenantId});
        case 6:
          return $state.go('main.tenantProofPlay', {tenantId: $stateParams.tenantId});
      }
    }
  });

  return vm;
}
export {TenantUnmanagedDevicesCtrl}
